// SEO content config for programmatic category x city landing pages.
// English is the primary language; Swedish mirrors are provided.

export const cities = [
  { slug: "stockholm", name: "Stockholm" },
  { slug: "goteborg", name: "Göteborg" },
  { slug: "malmo", name: "Malmö" },
  { slug: "uppsala", name: "Uppsala" },
  { slug: "vasteras", name: "Västerås" },
  { slug: "orebro", name: "Örebro" },
  { slug: "linkoping", name: "Linköping" },
  { slug: "helsingborg", name: "Helsingborg" },
  { slug: "norrkoping", name: "Norrköping" },
  { slug: "lund", name: "Lund" },
  { slug: "umea", name: "Umeå" },
  { slug: "jonkoping", name: "Jönköping" },
  { slug: "gavle", name: "Gävle" },
  { slug: "boras", name: "Borås" },
  { slug: "eskilstuna", name: "Eskilstuna" },
];

// Per category: order matches the seeded backend categories where possible.
export const seoCategories = {
  dj: {
    slug: "dj", category_id: "dj",
    en: { name: "DJ", plural: "DJs", desc: "Book a professional DJ for weddings, corporate parties, club nights and private events. Get priced offers from verified DJs, fast." },
    sv: { name: "DJ", plural: "DJ:s", desc: "Boka en professionell DJ till bröllop, företagsfester, klubbkvällar och privata event. Få prissatta bud från verifierade DJ:s, snabbt." },
  },
  "live-music": {
    slug: "live-music", category_id: "live_music", article: "",
    en: { name: "live music", plural: "live music acts", desc: "Book live music for your event - bands, singers, saxophonists and instrumentalists. Compare priced offers from verified acts across Sweden." },
    sv: { name: "livemusik", plural: "livemusikakter", desc: "Boka livemusik till ditt event - band, sångare, saxofonister och instrumentalister. Jämför prissatta bud från verifierade akter i Sverige." },
  },
  "hosts-entertainment": {
    slug: "hosts-entertainment", category_id: "hosts_entertainment",
    en: { name: "host or entertainer", plural: "hosts and entertainers", desc: "Book a toastmaster, event MC, comedian or magician to host and entertain your guests. Verified acts, priced offers, fast." },
    sv: { name: "värd eller underhållare", plural: "värdar och underhållare", desc: "Boka en toastmaster, konferencier, komiker eller trollkonstnär som leder och underhåller dina gäster. Verifierade akter, prissatta bud, snabbt." },
  },
  "event-services": {
    slug: "event-services", category_id: "event_services",
    en: { name: "event service", plural: "event services", desc: "Book event services - photo booths, bartenders and event staff - to complete your event. Compare offers from verified providers." },
    sv: { name: "eventtjänst", plural: "eventtjänster", desc: "Boka eventtjänster - fotobox, bartenders och eventpersonal - som kompletterar ditt event. Jämför bud från verifierade leverantörer." },
  },
  band: {
    slug: "band", category_id: "band",
    en: { name: "live band", plural: "live bands", desc: "Book a live band for any occasion, from intimate acoustic sets to full stage shows. Compare offers from verified acts." },
    sv: { name: "liveband", plural: "liveband", desc: "Boka ett liveband för alla tillfällen, från intima akustiska set till fullskaliga scenshower. Jämför bud från verifierade akter." },
  },
  singer: {
    slug: "singer", category_id: "singer",
    en: { name: "singer", plural: "singers", desc: "Book a professional singer for weddings, ceremonies and events. Receive offers from verified vocalists across every genre." },
    sv: { name: "sångare", plural: "sångare", desc: "Boka en professionell sångare till bröllop, ceremonier och event. Ta emot bud från verifierade sångare i alla genrer." },
  },
  troubadour: {
    slug: "troubadour", category_id: "troubadour",
    en: { name: "troubadour", plural: "troubadours", desc: "Book a troubadour to set the mood with live acoustic music and sing-alongs for your event." },
    sv: { name: "trubadur", plural: "trubadurer", desc: "Boka en trubadur som sätter stämningen med levande akustisk musik och allsång på ditt event." },
  },
  saxophonist: {
    slug: "saxophonist", category_id: "saxophonist",
    en: { name: "saxophonist", plural: "saxophonists", desc: "Book a saxophonist to add live energy alongside your DJ or band. Perfect for parties and receptions." },
    sv: { name: "saxofonist", plural: "saxofonister", desc: "Boka en saxofonist som tillför levande energi tillsammans med din DJ eller ditt band. Perfekt för fester och mottagningar." },
  },
  magician: {
    slug: "magician", category_id: "magician",
    en: { name: "magician", plural: "magicians", desc: "Book a magician for close-up magic or stage illusions that leave your guests amazed." },
    sv: { name: "trollkarl", plural: "trollkarlar", desc: "Boka en trollkarl för närmagi eller scenillusioner som förbluffar dina gäster." },
  },
  comedian: {
    slug: "comedian", category_id: "comedian",
    en: { name: "comedian", plural: "comedians", desc: "Book a comedian to bring the laughs to your corporate event, party or private function." },
    sv: { name: "komiker", plural: "komiker", desc: "Boka en komiker som bjuder på skratt till ditt företagsevent, din fest eller privata tillställning." },
  },
  mc: {
    slug: "mc", category_id: "mc",
    en: { name: "host", plural: "hosts", desc: "Book a host or MC to keep your event running smoothly and your guests engaged from start to finish." },
    sv: { name: "konferencier", plural: "konferencierer", desc: "Boka en konferencier som håller ditt event flytande och dina gäster engagerade från början till slut." },
  },
  pianist: {
    slug: "pianist", category_id: "pianist",
    en: { name: "pianist", plural: "pianists", desc: "Book a pianist for elegant live music at weddings, dinners and receptions." },
    sv: { name: "pianist", plural: "pianister", desc: "Boka en pianist för elegant levande musik på bröllop, middagar och mottagningar." },
  },
  dancer: {
    slug: "dancer", category_id: "dancer",
    en: { name: "dancer", plural: "dancers", desc: "Book dancers to add a spectacular visual performance to your event or show." },
    sv: { name: "dansare", plural: "dansare", desc: "Boka dansare som tillför ett spektakulärt visuellt framträdande till ditt event eller din show." },
  },
  bartender: {
    slug: "bartender", category_id: "bartender",
    en: { name: "bartender", plural: "bartenders", desc: "Book a professional bartender or flair bartender to serve up drinks and a show at your event." },
    sv: { name: "bartender", plural: "bartenders", desc: "Boka en professionell bartender eller flairbartender som serverar drinkar och en show på ditt event." },
  },
  photo_booth: {
    slug: "photo-booth", category_id: "photo_booth",
    en: { name: "photo booth", plural: "photo booths", desc: "Book a photo booth to give your guests fun, shareable memories from your event." },
    sv: { name: "fotobox", plural: "fotoboxar", desc: "Boka en fotobox som ger dina gäster roliga, delbara minnen från ditt event." },
  },
  // ---- Category-group level pages (match CATEGORY_GROUPS slugs) ----
  music: {
    slug: "music", category_id: "music",
    en: { name: "musician", plural: "musicians", desc: "Book live music - bands, singers, pianists and more - for weddings, corporate events and parties." },
    sv: { name: "musiker", plural: "musiker", desc: "Boka levande musik - band, sångare, pianister och mer - till bröllop, företagsevent och fester." },
  },
  "hosts-speakers": {
    slug: "hosts-speakers", category_id: "hosts_speakers",
    en: { name: "host or speaker", plural: "hosts and speakers", desc: "Book a host, MC or keynote speaker to keep your event running smoothly and your guests engaged." },
    sv: { name: "värd eller talare", plural: "värdar och talare", desc: "Boka en värd, konferencier eller keynote-talare som håller ditt event flytande och gästerna engagerade." },
  },
  entertainment: {
    slug: "entertainment", category_id: "entertainment",
    en: { name: "entertainer", plural: "entertainers", desc: "Book entertainment - magicians, dancers, circus and fire performers - to wow your guests." },
    sv: { name: "underhållare", plural: "underhållare", desc: "Boka underhållning - magiker, dansare, cirkus- och eldshower - som imponerar på dina gäster." },
  },
  experiences: {
    slug: "experiences", category_id: "experiences",
    en: { name: "experience", plural: "experiences", desc: "Book event experiences - mixologists, photo booths and more - to make your event unforgettable." },
    sv: { name: "upplevelse", plural: "upplevelser", desc: "Boka eventupplevelser - mixologister, fotoboxar och mer - som gör ditt event oförglömligt." },
  },
  comedy: {
    slug: "comedy", category_id: "comedy",
    en: { name: "comedian", plural: "comedians", desc: "Book stand-up comedians, comedy MCs and improv acts for corporate events, parties and clubs." },
    sv: { name: "komiker", plural: "komiker", desc: "Boka ståuppkomiker, komedi-MC:s och improvisationsakter till företagsevent, fester och klubbar." },
  },
};

// Map a landing-page slug to a CATEGORY_GROUPS id (used to filter live talents).
const SLUG_TO_GROUP = {
  dj: "dj", band: "live_music", singer: "live_music", troubadour: "live_music", saxophonist: "live_music",
  pianist: "live_music", magician: "hosts_entertainment", dancer: "hosts_entertainment", comedian: "hosts_entertainment",
  mc: "hosts_entertainment", bartender: "event_services", "photo-booth": "event_services",
  music: "live_music", "hosts-speakers": "hosts_entertainment", entertainment: "hosts_entertainment",
  experiences: "event_services", comedy: "hosts_entertainment",
  "live-music": "live_music", "hosts-entertainment": "hosts_entertainment", "event-services": "event_services",
};
export const groupForSlug = (slug) => SLUG_TO_GROUP[slug] || slug;

export const findCategoryBySlug = (slug) =>
  Object.values(seoCategories).find((c) => c.slug === slug);
export const findCity = (slug) => cities.find((c) => c.slug === slug);

// Localized copy builders
export const buildCopy = (cat, city, lang) => {
  const c = cat[lang];
  const cityName = city ? city.name : null;
  if (lang === "sv") {
    return {
      h1: `Boka ${c.name}${cityName ? ` i ${cityName}` : " i Sverige"}`,
      intro: `${c.desc}${cityName ? ` Vi hjälper dig att hitta rätt ${c.name} i ${cityName}.` : ""}`,
      metaTitle: `Boka ${c.name}${cityName ? ` i ${cityName}` : ""} | Talentsio`,
      metaDesc: `${c.desc} Gratis att skicka en förfrågan, fast slutpris.`,
      cta: "Skicka en gratis förfrågan",
      otherCitiesTitle: `Boka ${c.name} i andra städer`,
      faq: [
        { q: `Vad kostar det att boka ${c.name}${cityName ? ` i ${cityName}` : ""}?`, a: `Priset varierar beroende på event, längd och artist. Skicka en gratis förfrågan så får du prissatta bud från verifierade ${c.plural} att jämföra.` },
        { q: `Hur bokar jag ${c.name}${cityName ? ` i ${cityName}` : ""}?`, a: `Lägg upp en gratis förfrågan med datum, plats och budget. Verifierade ${c.plural} skickar bud direkt till dig och du väljer det som passar bäst.` },
        { q: `Hur lång tid tar det att få bud?`, a: `De flesta förfrågningar får sitt första bud inom några timmar.` },
        { q: `Är det gratis att skicka en förfrågan?`, a: `Ja. Att skicka en förfrågan och ta emot bud är helt gratis. Kunden betalar fast slutpris inkl. allt.` },
        { q: `Är alla talanger verifierade?`, a: `Ja. Varje talang granskas och godkänns av vårt team innan de kan ta emot förfrågningar.` },
      ],
    };
  }
  const art = cat.article !== undefined ? cat.article : (/^[aeiou]/i.test(c.name) ? "an" : "a");
  const ap = art ? `${art} ` : "";
  return {
    h1: `Book ${ap}${c.name}${cityName ? ` in ${cityName}` : " in Sweden"}`,
    intro: `${c.desc}${cityName ? ` We help you find the right ${c.name} in ${cityName}.` : ""}`,
    metaTitle: `Book ${ap}${c.name}${cityName ? ` in ${cityName}` : ""} | Talentsio`,
    metaDesc: `${c.desc} Free to post a request, fixed final price.`,
    cta: "Post a free request",
    otherCitiesTitle: `Book ${ap}${c.name} in other cities`,
    faq: [
      { q: `How much does ${ap || "it "}${c.name ? c.name : ""} cost${cityName ? ` in ${cityName}` : ""}?`.replace("  ", " "), a: `Pricing varies by event, length and performer. Post a free request and receive priced offers from verified ${c.plural} to compare.` },
      { q: `How do I book ${ap}${c.name}${cityName ? ` in ${cityName}` : ""}?`, a: `Post a free request with your date, location and budget. Verified ${c.plural} send offers directly to you, and you choose the one that fits best.` },
      { q: `How long does it take to get offers?`, a: `Most requests receive their first offer within a few hours.` },
      { q: `Is it free to post a request?`, a: `Yes. Posting a request and receiving offers is completely free. Customers pay a fixed final price.` },
      { q: `Are talents verified?`, a: `Yes. Every talent is reviewed and approved by our team before they can receive requests.` },
    ],
  };
};
